import type * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Form label. Every form needs one and every one needs `htmlFor`, so this
 * exists as much for the association as for the styling.
 */
export function Label({ className, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) {
  // biome-ignore lint/a11y/noLabelWithoutControl: htmlFor is required by callers via props
  return <label className={cn('text-[15px] font-semibold text-ink-2', className)} {...props} />;
}
